module.exports = __webpack_public_path__ + "static/img/img_relatedproducts_2.4c12a17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_relatedproducts_2.png
// module id = 0s5l
// module chunks = 0